// components/utils/ottoCalStore.ts
// 로봇 맞추기(보정) 값을 이 컴퓨터(브라우저 localStorage)에 보드 MAC 별로 보관한다.
// 펌웨어를 다시 설치하면 보드의 NVS 가 지워지므로, 그때 이 값을 보드에 자동으로 되돌려 넣는다.
// 이 컴퓨터, 이 브라우저, 이 사이트 주소에서만 보인다. (다른 컴퓨터까지 보장하지 않는다)

export interface OttoCalValues {
  yl: number; // 왼쪽 다리 수직 펄스폭(us)
  yr: number; // 오른쪽 다리
  tr: number; // 걷기: 오른발 기울기
  tl: number; // 걷기: 왼발 기울기
  rl: number; // 왼발 굴림 속도(us)
  rr: number; // 오른발 굴림 속도(us)
}

export interface StoredOttoCal {
  v: OttoCalValues;
  at: number; // 저장한 시각 (ms)
}

const keyOf = (mac: string) => `ottoCal:${mac}`;

// 펌웨어와 라이브러리가 쓰는 범위와 같다
export function isValidCal(v: any): v is OttoCalValues {
  const inRange = (x: any, lo: number, hi: number) => typeof x === 'number' && Number.isFinite(x) && x >= lo && x <= hi;
  return !!v
    && inRange(v.yl, 1000, 1900) && inRange(v.yr, 1000, 1900)
    && inRange(v.tr, 0, 45) && inRange(v.tl, 0, 45)
    && inRange(v.rl, 0, 600) && inRange(v.rr, 0, 600);
}

export function loadStoredCal(mac: string): StoredOttoCal | null {
  try {
    const raw = window.localStorage.getItem(keyOf(mac));
    if (!raw) return null;
    const j = JSON.parse(raw);
    if (!isValidCal(j?.v)) return null;
    return { v: j.v, at: typeof j.at === 'number' ? j.at : 0 };
  } catch (e) {
    return null; // 저장소를 못 쓰는 환경이면 없는 것으로 본다
  }
}

export function saveStoredCal(mac: string, v: OttoCalValues): void {
  try {
    if (!isValidCal(v)) return;
    window.localStorage.setItem(keyOf(mac), JSON.stringify({ v, at: Date.now() }));
  } catch (e) {
    // 저장소를 못 쓰면 건너뛴다 (보드 NVS 저장은 그대로 된다)
  }
}

export function clearStoredCal(mac: string): void {
  try {
    window.localStorage.removeItem(keyOf(mac));
  } catch (e) {
    // 무시
  }
}
